import { render, staticRenderFns } from "./ParentConnect.vue?vue&type=template&id=0852053e&scoped=true"
import script from "./ParentConnect.vue?vue&type=script&lang=js"
export * from "./ParentConnect.vue?vue&type=script&lang=js"
import style0 from "./ParentConnect.vue?vue&type=style&index=0&id=0852053e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0852053e",
  null
  
)

export default component.exports